import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { ProductionListScope } from './prod-list-scope'

@Directive({
  selector: '[appProdListScopeSelect]',
})
export class ProdListScopeSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.placeholder = 'context.scope'
    this.select.displayProperty = 'displayValue'
    this.select.dataSource = enumTranslationService.enumDataSource(
      ProductionListScope,
      'prod_list_scope'
    )
  }
}
